/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { jobsGet } from "../../funcs/jobsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.GetApiLeadScraperMicroserviceApiV1JobsJobIdRequest$inboundSchema,
};

export const tool$jobsGet: ToolDefinition<typeof args> = {
  name: "jobs_get",
  description: `Get a specific job

This endpoint retrieves a specific Google Maps scraping job`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await jobsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
